export default class Errors {
  private errors: any
  /**
   * Create a new Errors instance.
   */
  constructor() {
    this.errors = {}
  }


  /**
   * Determine if an errors exists for the given field.
   *
   * @param {string} field
   */
  public has(field: string) {
    return this.errors.hasOwnProperty(field)
  }


  /**
   * Determine if we have any errors.
   */
  public any() {
    return Object.keys(this.errors).length > 0
  }


  /**
   * Retrieve the error message for a field.
   *
   * @param {string} field
   */
  public get(field: string) {
    if (this.errors[field]) {
      return this.errors[field][0]
    }
  }


  /**
   * Record the new errors.
   *
   * @param {object} errors
   */
  public record(errors: any) {
    this.errors = errors
  }


  /**
   * Clear one or all error fields.
   *
   * @param {string|null} field
   */
  public clear(field?: string) {
    if (field) {
      delete this.errors[field]
      return
    }

    this.errors = {}
  }
}
